import { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import { TrendingUp, TrendingDown, BarChart3 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PricingTicker() {
  const [prices, setPrices] = useState([]);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const res = await axios.get(`${API}/prices`);
        setPrices(res.data);
      } catch {
        setPrices([
          { name: "HR Coil", symbol: "HRC", price: 48500, change: 0, unit: "INR/t" },
          { name: "CR Coil", symbol: "CRC", price: 55200, change: 0, unit: "INR/t" },
          { name: "TMT Bar", symbol: "TMT", price: 45800, change: 0, unit: "INR/t" },
          { name: "Billet", symbol: "BLT", price: 38500, change: 0, unit: "INR/t" },
        ]);
      }
    };
    fetchPrices();
    const interval = setInterval(fetchPrices, 10000);
    return () => clearInterval(interval);
  }, []);

  if (prices.length === 0) return null;

  return (
    <div data-testid="pricing-ticker" className="relative border-y border-ib-steel/20 bg-ib-surface/50">
      <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-ib-bg to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-ib-bg to-transparent z-10 pointer-events-none" />

      {/* Live indicator */}
      <div className="absolute left-4 top-1/2 -translate-y-1/2 z-20 flex items-center gap-1.5">
        <BarChart3 className="w-3 h-3 text-ib-blue" />
        <span className="font-jetbrains text-[9px] text-ib-text-muted tracking-wider">LIVE</span>
        <span className="w-1.5 h-1.5 rounded-full bg-ib-lime animate-pulse" />
      </div>

      <Marquee speed={35} gradient={false} className="py-3 pl-20">
        {prices.map((p) => (
          <div key={p.symbol} className="flex items-center gap-3 mx-8">
            <span className="font-jetbrains text-xs font-bold text-ib-text-muted">{p.symbol}</span>
            <span className="font-jetbrains text-sm font-semibold text-ib-text">
              ₹{p.price.toLocaleString("en-IN")}
            </span>
            <span className={`flex items-center gap-1 font-jetbrains text-xs ${p.change >= 0 ? "text-ib-positive" : "text-ib-negative"}`}>
              {p.change >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
              {p.change >= 0 ? "+" : ""}{p.change}%
            </span>
            {p.volume && (
              <span className="font-jetbrains text-[9px] text-ib-text-muted">
                Vol: {p.volume}
              </span>
            )}
            <span className="font-jetbrains text-[10px] text-ib-text-muted">{p.unit}</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
